// 하드웨어/시스템 뒤로가기 추상화.
//  - Capacitor 네이티브에서는 App 플러그인의 backButton 이벤트로 정확히 제어한다(권장 경로).
//  - 의존성 없이 동작하도록 window.Capacitor.Plugins.App 에 동적 접근한다(미설치/웹에서는 no-op).

interface CapacitorAppPlugin {
  addListener(eventName: string, cb: () => void): unknown;
  exitApp?: () => void;
}

function getCapacitorApp(): CapacitorAppPlugin | null {
  const cap = (globalThis as { Capacitor?: { Plugins?: { App?: CapacitorAppPlugin } } }).Capacitor;
  return cap?.Plugins?.App ?? null;
}

// 네이티브 하드웨어 뒤로가기 핸들러 등록. 반환값으로 해제한다(웹/미지원이면 no-op).
export function registerHardwareBack(handler: () => void): () => void {
  const app = getCapacitorApp();
  if (!app?.addListener) {
    return () => undefined;
  }
  const sub = app.addListener("backButton", handler) as
    | { remove?: () => void }
    | Promise<{ remove?: () => void }>;
  return () => {
    Promise.resolve(sub)
      .then((s) => s?.remove?.())
      .catch(() => undefined);
  };
}

// 네이티브 앱 종료(웹에서는 no-op).
export function exitNativeApp(): void {
  getCapacitorApp()?.exitApp?.();
}
